import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../SharedModule';
import { NavbarComponent } from '../navbar/navbar.component';
import { SecurityService } from '../../../services/security';
import * as crypto from "crypto-js";
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-common',
  standalone: true,
  imports: [
    SharedModule,
    NavbarComponent
  ],
  templateUrl: './common.component.html',
  styleUrls: ['./common.component.css']
})
export class CommonComponent implements OnInit {

  language !: any;
  user !: string;
  name !: string;
  options: any = {};

  constructor(
    private __securityService: SecurityService
  ) {
  }

  ngOnInit(): void {
    this.options = JSON.parse(''+sessionStorage.getItem('permissions')) ?? {};
    if (sessionStorage.getItem('profile') == undefined) {
      this.getInfoUser();
    } else {
      this.user = localStorage.getItem('user')!;
      this.name = localStorage.getItem('name')!;
    }
  }

  getInfoUser(){
    let usEnc = ''+localStorage.getItem('user');
    let param = {
      "password": '',
      "mail": usEnc,
      "loginType": 1
    }

    this.__securityService.authentication(param).subscribe( (data: any) => {
      if(data.an_resultado == 1){
        localStorage.setItem('name', data.res_obj_login.name);
        localStorage.setItem('mail', data.res_obj_login.mail);
        if (data.res_obj_login.permissions.roles[0]?.roleDesc?.length > 0) {
          localStorage.setItem('profile', data.res_obj_login.permissions.roles[0]?.roleDesc);
        }
        if (data.res_obj_login.permissions.roles[0]?.roleDesc == 'Contractors') {
          localStorage.setItem('userCod', data.res_obj_login.username);
          localStorage.setItem('employeer', data.res_obj_login.employeer);
        }
        sessionStorage.setItem('permissions', JSON.stringify(data.res_obj_login.permissions));
        this.options = data.res_obj_login.permissions;
      }
    });

  }

}
